import {
  Stack,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { paperMaterialBusiness } from "api/bussiness/paper-material/paper-material-bussiness";
import { invalidatePaperCatalogCache } from "api/cached";
import { PaperMaterialsPermission } from "commons/enum/permission";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { IPaperMaterialProperties } from "mobx-stores/_models/paper-inventory/paper-material";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { NumberText } from "share-components/atomics/number-text";
import {
  EditIconButton,
  RemoveIconButton,
} from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const PaperMaterialTable = observer(() => {
  const queryClient = useQueryClient();
  const {
    deleteConfirmationStore,
    paperMaterialStore: {
      paperMaterials,
      getPapersMaterial,
      pagination,
      setProp,
    },
  } = useStores();

  useEffect(() => {
    getPapersMaterial();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getPapersMaterial();
    },
    [getPapersMaterial, pagination],
  );

  const onEditBtnClickHandler = useCallback(
    (item: IPaperMaterialProperties) => {
      setProp("openEdit", true);
      setProp("paperMaterialDetail", cloneDeep(item));
    },
    [setProp],
  );

  const onDelete = useCallback(
    async (item: IPaperMaterialProperties) => {
      if (item && item.id) {
        await paperMaterialBusiness.delete(item?.id);
        await invalidatePaperCatalogCache(queryClient);
        getPapersMaterial();
      }
    },
    [getPapersMaterial, queryClient],
  );

  const onDeleteBtnClickHandler = useCallback(
    (item: IPaperMaterialProperties) => {
      setProp("paperMaterialDetail", cloneDeep(item));
      deleteConfirmationStore.setProp("open", true);
      deleteConfirmationStore.setDeletionCallback(() => {
        onDelete(item);
      });
    },
    [deleteConfirmationStore, onDelete, setProp],
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageNumber,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>Mã số</TableCell>
          <TableCell>Loại giấy</TableCell>
          <TableCell>GSM</TableCell>
          <TableCell>Quy cách giấy - Dạng</TableCell>
          <TableCell>Quy cách giấy - Khổ</TableCell>
          <TableCell>Quy cách giấy - Dài</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {paperMaterials.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.code || ""}</TableCell>
            <TableCell>{x.type || ""}</TableCell>
            <TableCell>
              <NumberText value={x.gsm}></NumberText>
            </TableCell>
            <TableCell>{x.specificationType || ""}</TableCell>
            <TableCell>
              <NumberText value={x.specificationSize}></NumberText>
            </TableCell>
            <TableCell>
              <NumberText value={x.specificationLength}></NumberText>
            </TableCell>
            <TableCell width={"20px"}>
              <Stack direction={"row"} spacing={0.5}>
                <EditIconButton
                  accessPermission={[PaperMaterialsPermission.Update]}
                  onClick={() => onEditBtnClickHandler(x)}
                ></EditIconButton>

                <RemoveIconButton
                  accessPermission={[PaperMaterialsPermission.Delete]}
                  onClick={() => onDeleteBtnClickHandler(x)}
                ></RemoveIconButton>
              </Stack>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

